/* Extends the existing calculator after its adhesive step. No cart-wide panel inference. */
(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-dsv2-wall-calculator]').forEach(root => {
      const dialog = root.querySelector('[data-wall-flow]');
      if (!dialog || dialog.dataset.initialized) return;
      dialog.dataset.initialized = 'true';
      const lifecycle = new AbortController();
      const on = (node, type, fn) => node.addEventListener(type, fn, { signal: lifecycle.signal });
      const $ = selector => dialog.querySelector(selector);
      const strings = JSON.parse($('[data-flow-strings]').textContent);
      const t = (key, values = {}) => Object.entries(values).reduce((s, [k, v]) => s.replaceAll(`{${k}}`, v), strings[key]);
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'he-IL', { style: 'currency', currency: root.dataset.currency || 'ILS' }).format(cents / 100);
      const input = $('[data-flow-quantity]'), add = $('[data-flow-add]'), next = $('[data-flow-next]');
      let stage = 'connector', wall = null, busy = false, completed = false, uncertain = false, quantity = null, savedOverflow = '', previousFocus;
      const product = () => $(`[data-flow-product="${stage === 'connector' ? 'connector' : 'trim'}"]`);
      const available = () => product().dataset.available === 'true' && Number(product().dataset.id) > 0;
      const set = (selector, text) => { $(selector).textContent = text; };
      const show = (selector, visible) => { $(selector).hidden = !visible; };
      function focusTitle() {
        $('.dsv2-glue-modal__dialog').scrollTop = 0;
        $('[data-flow-title]').focus({ preventScroll: true });
      }
      function updateTotal() {
        const q = Number(input.value);
        const buttons = input.closest('quantity-selector')?.querySelectorAll('button');
        if (buttons) { buttons[0].disabled = input.disabled || q <= Number(input.min); buttons[1].disabled = input.disabled || (input.hasAttribute('max') && q >= Number(input.max)); }
        set('[data-flow-total]', money(Number(product().dataset.price) * (Number.isFinite(q) ? q : 0)));
        add.disabled = busy || completed || uncertain || !available() || !Number.isSafeInteger(q) || q < 1;
      }
      function controls() {
        const purchase = quantity > 0;
        show('[data-flow-purchase]', purchase);
        show('[data-flow-edges]', stage === 'trim' && quantity === null);
        show('[data-flow-selection]', stage === 'trim' && quantity !== null);
        dialog.querySelectorAll('[data-flow-product]').forEach(el => { el.hidden = el !== product(); });
        show('[data-flow-unavailable]', purchase && !available());
        show('[data-flow-consult]', purchase && !available());
        show('[data-flow-add]', purchase && available() && !completed && !uncertain);
        show('[data-flow-next]', stage === 'connector' || quantity !== null);
        next.textContent = stage === 'connector' ? t(completed ? 'connector_done_next' : !purchase ? 'next' : 'skip_connector') : t(completed ? 'trim_done_next' : !purchase ? 'finish' : 'skip_trim');
        next.setAttribute('aria-label', next.textContent);
        next.dataset.primary = String(completed || !purchase || !available());
        show('[data-flow-back]', stage === 'trim' && quantity !== null && !completed && !uncertain);
        input.disabled = busy || completed || uncertain || !available();
        next.disabled = busy;
        dialog.querySelectorAll('[data-flow-close], [data-flow-back], [data-edge-choice], [data-partial-choice]').forEach(el => { el.disabled = busy || ((completed || uncertain) && el.matches('input')); });
        updateTotal();
      }
      function recommend(q) {
        quantity = q;
        if (stage === 'trim' && q !== null) {
          const selected = $('[data-edge-choice]:checked')?.value;
          const part = $('[data-partial-choice]:checked')?.value;
          set('[data-flow-selection]', selected === 'partial' ? `${t('partial')} · ${t(part)}` : t(selected));
        }
        input.value = Math.max(q || 0, 1);
        set('[data-flow-recommendation]', q === null ? '' : t(stage === 'connector' ? (q ? 'connector_count' : 'one_panel') : (q ? 'trim_count' : 'no_trim'), { quantity: q }));
        controls();
        if (stage === 'trim' && q !== null) focusTitle();
      }
      function startStage(type) {
        stage = type; completed = false; uncertain = false; busy = false;
        show('[data-flow-success]', false); show('[data-flow-error]', false); show('[data-flow-cart]', false);
        add.textContent = t('add'); add.removeAttribute('aria-busy');
        set('[data-flow-step]', t(type === 'connector' ? 'step_connector' : 'step_trim'));
        set('[data-flow-title]', t(type === 'connector' ? 'connector_title' : 'edges_title'));
        set('[data-flow-copy]', t(type === 'connector' ? 'connector_copy' : 'edges_copy'));
        set('[data-flow-context]', t('context', { panels: wall.panels }));
        show('[data-flow-edges]', type === 'trim');
        show('[data-partial-edges]', false);
        dialog.querySelectorAll('input[type=radio]').forEach(el => { el.checked = false; el.disabled = false; });
        recommend(type === 'connector' ? Math.max(0, wall.panels - 1) : null);
        focusTitle();
      }
      async function finish() {
        if (busy) return;
        busy = true; controls();
        next.textContent = t('checking_accessories');
        next.setAttribute('aria-label', next.textContent);
        next.setAttribute('aria-busy', 'true');
        await refreshAccessories();
        if (!root.isConnected) return;
        busy = false; next.removeAttribute('aria-busy');
        dialog.close(); dialog.hidden = true;
        document.documentElement.style.overflow = savedOverflow;
        delete document.documentElement.dataset.dsv2GlueOpen;
        const target = document.querySelector('[data-dsv2-accessories] .dsv2-accessory-row:not([hidden])') || document.querySelector('[data-dsv2-accessories]') || root.querySelector('[data-after-apply]') || previousFocus;
        target?.focus({ preventScroll: true });
        target?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }
      on(root, 'dsv3:wall-added', event => {
        if (dialog.open || busy) return;
        const detail = event.detail;
        if (!Number.isSafeInteger(detail?.panels) || detail.panels < 1 || !(detail.height > 0 && detail.height <= Number(root.dataset.unitHeight))) return;
        wall = detail;
        previousFocus = document.activeElement; savedOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        document.documentElement.dataset.dsv2GlueOpen = 'true';
        dialog.hidden = false; dialog.showModal(); startStage('connector');
      });
      dialog.querySelectorAll('[data-edge-choice]').forEach(el => on(el, 'change', () => {
        if (busy || completed || uncertain) return;
        const partial = el.value === 'partial';
        show('[data-partial-edges]', partial);
        dialog.querySelectorAll('[data-partial-choice]').forEach(radio => { radio.checked = false; });
        recommend(partial ? null : el.value === 'both' ? 2 : el.value === 'none' ? 0 : 1);
      }));
      dialog.querySelectorAll('[data-partial-choice]').forEach(el => on(el, 'change', () => {
        if (!busy && !completed && !uncertain) recommend(el.value === 'both' ? 2 : 1);
      }));
      on($('[data-flow-back]'), 'click', () => { if (!busy && !completed && !uncertain) startStage('trim'); });
      on(next, 'click', () => { if (!busy) { if (stage === 'connector') startStage('trim'); else finish(); } });
      dialog.querySelectorAll('[data-flow-close]').forEach(el => on(el, 'click', finish));
      on(dialog, 'cancel', event => { event.preventDefault(); finish(); });
      on(input, 'input', updateTotal);
      on(input, 'change', updateTotal);
      const route = () => window.Shopify?.routes?.root || '/';
      async function getCart() {
        const response = await fetch(`${route()}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store', signal: AbortSignal.timeout(15000) });
        if (!response.ok) throw new Error('cart unavailable');
        return response.json();
      }
      const count = (cart, id) => cart.items.filter(i => String(i.variant_id) === String(id)).reduce((n, i) => n + i.quantity, 0);
      let cartRequest = 0;
      function filterAccessories(cart) {
        const section = document.querySelector('[data-dsv2-accessories]');
        if (!section) return;
        const guided = Array.from(dialog.querySelectorAll('[data-flow-product]'));
        const rows = Array.from(section.querySelectorAll('[data-accessory-product-id]'));
        rows.forEach(row => {
          const match = guided.find(item => item.dataset.productId === row.dataset.accessoryProductId);
          // Only the exact guided variant can suppress its matching accessory row.
          row.hidden = !!(cart && match?.dataset.id && count(cart, match.dataset.id) > 0);
        });
        const empty = section.querySelector('[data-flow-accessories-empty]');
        if (empty) empty.hidden = !rows.length || rows.some(row => !row.hidden);
      }
      async function refreshAccessories() {
        const request = ++cartRequest;
        try {
          const cart = await getCart();
          if (!lifecycle.signal.aborted && request === cartRequest) filterAccessories(cart);
        } catch (_) {
          // Never suppress a product when the current cart cannot be verified.
          if (!lifecycle.signal.aborted && request === cartRequest) filterAccessories(null);
        }
      }
      on(document, 'cart:refresh', refreshAccessories);
      on(document, 'cart:change', refreshAccessories);
      on(window, 'pageshow', refreshAccessories);
      on(window, 'focus', refreshAccessories);
      refreshAccessories();
      function success(q, requested) {
        completed = true;
        set('[data-flow-success]', t(q === requested ? 'success' : 'partial_success', { quantity: q, requested }));
        show('[data-flow-success]', true);
        show('[data-flow-edges]', false);
        set('[data-flow-title]', t(stage === 'connector' ? 'connector_title' : 'trim_title'));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
      on(add, 'click', async () => {
        const requested = Number(input.value), id = Number(product().dataset.id);
        if (busy || completed || uncertain || !available() || !Number.isSafeInteger(requested) || requested < 1) return;
        busy = true; controls(); add.setAttribute('aria-busy', 'true'); add.textContent = t('adding');
        show('[data-flow-error]', false);
        let before = null, sent = false, status = 0;
        try {
          before = count(await getCart(), id);
          sent = true;
          const response = await fetch(`${route()}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: requested }] }), signal: AbortSignal.timeout(20000) });
          status = response.status;
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.description || t('error'));
          success(requested, requested);
        } catch (error) {
          let delta = null;
          if (sent && before !== null) {
            try { delta = count(await getCart(), id) - before; } catch (_) { /* Unknown results must not enable a second add. */ }
          }
          if (delta > 0 && delta <= requested) success(delta, requested);
          else {
            uncertain = sent && !(delta === 0 && (status === 400 || status === 422));
            set('[data-flow-error]', uncertain ? t('unknown') : sent ? error.message : t('error'));
            show('[data-flow-error]', true); show('[data-flow-cart]', uncertain);
          }
        } finally {
          if (!root.isConnected) return;
          busy = false; add.removeAttribute('aria-busy'); add.textContent = t('add'); controls();
          if (completed) next.focus();
        }
      });
      on(document, 'shopify:section:unload', event => {
        if (!event.target.contains(root)) return;
        if (dialog.open) { dialog.close(); document.documentElement.style.overflow = savedOverflow; delete document.documentElement.dataset.dsv2GlueOpen; }
        lifecycle.abort();
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
